import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const wineBrClassificationsSchema: CollectionCreateSchema = {
  name: CollectionName.WineBrClassifications,
  fields: [
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "search_id",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "class_name",
      type: "string",
      facet: true,
    },
    {
      name: "sugar_content",
      type: "string",
      facet: true,
      optional: true,
    },
    {
      name: "group_order",
      type: "int32",
      facet: true,
      sort: true,
    },
    {
      name: "order",
      type: "int32",
      facet: true,
      sort: true,
      optional: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
